<template>
<div class="map-container">

  <div class="map-overlay" data-id="nonefound" :class="{ 's_active' : isEmpty }">
    <div class="map-overlay-text">
      <h3>No stores found</h3>
      <p>There currently are no Crowies stores available in this region</p>
    </div>
  </div>

  <div class="map-overlay" data-id="loading" :class="{ 's_active' : isLoading }">
    <div class="map-overlay-text">
      <!-- {{ inline('images/checkout-loader.svg')|raw }} -->
      <h3>Searching...</h3>
      <p>We're looking for your local Crowies!</p>
    </div>
  </div>

  <div class="map" ref="map"></div>

</div>
</template>

<script>
import MarkerClusterer from '@google/markerclusterer';
import EventBus from '../utils/event-bus';
import gmapsInit from '../utils/gmaps';

export default {
  name: "Gmap",
  data() {
    return {

      stores: [],

      isEmpty: false,
      isLoading: false,
      isReady: false,

      prevZoom: 10,

      map: false,
      markers: [],
      markerRefs: [],
      markerPositions: [],
      map_marker_image: '/images/marker.svg',
      map_marker_active_image: '/images/marker-active.svg',
      map_cluster_image: '/images/marker-cluster.svg',
      markerCluster: false,
      clusterMap: true,
      mapOptions: {},
      map_marker_image_element: false,
      map_marker_active_image_element: false,

      // map styles
      styles: [
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#d3d3d3"
                }
            ]
        },
        {
            "featureType": "transit",
            "stylers": [
                {
                    "color": "#808080"
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#b3b3b3"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "weight": 1.8
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#d7d7d7"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ebebeb"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#a7a7a7"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#efefef"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#696969"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#737373"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#d6d6d6"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {},
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
      ]

    };
  },
  props: {
    apikey: String,
    locations: Array,
    searchId: String,
    storeId: String,
    ignoreGlobal: {
      type: Boolean,
      default: false
    },
  },
  methods: {

    getExtraZoom(projection, expectedBounds, actualBounds) {

        // in: LatLngBounds bounds -> out: height and width as a Point
        function getSizeInPixels(bounds) {
            var sw = projection.fromLatLngToContainerPixel(bounds.getSouthWest());
            var ne = projection.fromLatLngToContainerPixel(bounds.getNorthEast());
            return new google.maps.Point(Math.abs(sw.y - ne.y), Math.abs(sw.x - ne.x));
        }

        var expectedSize = getSizeInPixels(expectedBounds),
            actualSize = getSizeInPixels(actualBounds);

        if (Math.floor(expectedSize.x) == 0 || Math.floor(expectedSize.y) == 0) {
            return 0;
        }

        var qx = actualSize.x / expectedSize.x;
        var qy = actualSize.y / expectedSize.y;
        var min = Math.min(qx, qy);

        if (min < 1) {
            return 0;
        }

        return Math.floor(Math.log(min) / Math.LN2 /* = log2(min) */);
    },

    fitBounds(bounds) {
      var myMap = this.map;
      myMap.fitBounds(bounds); // calling fitBounds() here to center the map for the bounds

      var overlayHelper = new google.maps.OverlayView();
      overlayHelper.draw = function () {
          if (!this.ready) {
              // var extraZoom = this.getExtraZoom(this.getProjection(), bounds, myMap.getBounds());
              // console.log(extraZoom);
              // if (extraZoom > 0) {
              //     myMap.setZoom(myMap.getZoom() + extraZoom);
              // }
              this.ready = true;
              google.maps.event.trigger(this, 'ready');
          }
      };
      overlayHelper.setMap(myMap);
    },

    initMap() {

      this.mapOptions = {
        zoom: 13,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        panControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        overviewMapControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL
        }
      };
      this.map = new google.maps.Map(this.$refs.map, this.mapOptions);
      this.map.setOptions({styles: this.styles});

      this.map_marker_image_element = new google.maps.MarkerImage(
        this.map_marker_image,
        null, /* size is determined at runtime */
        null, /* origin is 0,0 */
        new google.maps.Point(30, 30), /* anchor is bottom center of the scaled image */
        new google.maps.Size(60, 60));  /* Size given in CSS Length units */

      this.map_marker_active_image_element = new google.maps.MarkerImage(
        this.map_marker_active_image,
        null, /* size is determined at runtime */
        null, /* origin is 0,0 */
        new google.maps.Point(35, 35), /* anchor is bottom center of the scaled image */
        new google.maps.Size(70, 70));  /* Size given in CSS Length units */

    },

    setBounds(locations) {

      this.markerPositions = [];

      locations.forEach((element) => {

        var latlngset = new google.maps.LatLng(element.lat, element.lng);
        this.markerPositions.push(latlngset);

      });

      if (locations.length > 1) {

        // set bounds
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < this.markerPositions.length; i++) {
          bounds.extend(this.markerPositions[i]);
        }
        this.fitBounds(bounds);

      } else {

        this.map.setCenter(this.markerPositions[0]);
        this.map.setZoom(15);

      }

      this.mapReady();

    },

    setMarkers(locations) {

      this.markers = [];
      this.markerRefs = [];
      this.markerPositions = [];

      locations.forEach((store) => {

        var latlngset = new google.maps.LatLng(store.lat, store.lng);

        var marker = new google.maps.Marker({
          map: this.map,
          title: store.title,
          position: latlngset,
          icon: this.map_marker_image_element
        });
        this.map.setCenter(marker.getPosition())

        this.markers.push(marker);
        this.markerRefs[store.id] = marker;
        this.markerPositions.push(marker.getPosition());

        if (this.searchId == 'main') {
          google.maps.event.addListener(marker, 'click', () => {

            this.deactivateMarkers();
            marker.setIcon(this.map_marker_active_image_element);
            EventBus.$emit('STORE_DISPLAY', this.searchId, store);

          });
        } else if (this.searchId == 'sidebar') {
          google.maps.event.addListener(marker, 'click', () => {

            EventBus.$emit('LOCALSTORE_SET', store);

          });
          google.maps.event.addListener(marker, 'mouseover', () => {

            EventBus.$emit('STORE_HIGHLIGHT', this.searchId, store);

          });
          google.maps.event.addListener(marker, 'mouseout', () => {

            EventBus.$emit('STORE_UNHIGHLIGHT', this.searchId, store);

          });
        }

      });

      if (locations.length == 1) {
        this.map.setZoom(15);
      }

      if (locations.length > 1) {

        // set bounds
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < this.markerPositions.length; i++) {
          bounds.extend(this.markerPositions[i]);
        }
        this.fitBounds(bounds);

        // add marker clusterer
        if (this.clusterMap) {
          this.markerCluster = new MarkerClusterer(this.map, this.markers, {
            styles: [{
              url: this.map_cluster_image,
              height: 60,
              width: 60,
              anchor: [0, 0],
              textColor: '#ffffff',
              textSize: 20
            }],
            gridSize: 25,
          });
        }

      }

      this.mapReady();

    },

    activateMarker(storeId) {

      this.markerRefs[storeId].setIcon(this.map_marker_active_image_element);
      this.map.panTo(this.markerRefs[storeId].position);
      this.prevZoom = this.map.getZoom();
      this.map.setZoom(16);
      // this.smoothZoom(map, 14, map.getZoom());

    },

    deactivateMarkers() {

      this.markers.forEach((marker) => {
        marker.setIcon(this.map_marker_image_element);
      });

      // this.smoothZoomOut(map, 13, map.getZoom());
      // map.setZoom(13);

    },

    highlightMarker(storeId) {

      this.markerRefs[storeId].setIcon(this.map_marker_active_image_element);

    },

    unhighlightMarker(storeId) {

      this.markerRefs[storeId].setIcon(this.map_marker_image_element);

    },

    smoothZoom (map, max, cnt) {
      if (cnt >= max) {
        return;
      }
      else {
        var z = google.maps.event.addListener(map, 'zoom_changed', (event) => {
            google.maps.event.removeListener(z);
            this.smoothZoom(map, max, cnt + 1);
        });
        setTimeout(function(){map.setZoom(cnt)}, 80);
      }
    },

    smoothZoomOut (map, min, cnt) {
      if (cnt <= min) {
        return;
      }
      else {
        var z = google.maps.event.addListener(map, 'zoom_changed', (event) => {
            google.maps.event.removeListener(z);
            this.smoothZoom(map, min, cnt - 1);
        });
        setTimeout(function(){map.setZoom(cnt)}, 80);
      }
    },

    mapReady () {
      setTimeout(() => {this.isLoading = false}, 200);
    }

  },
  watch: {
    // locations: this.setMap(locations)
  },
  beforeMounted() {
// this.setMap(this.stores);
  },
  created() {
// console.log(this.locations);

  },
  async mounted() {

    // get stores array
    if (typeof window.stores !== 'undefined') {
      this.stores = window.stores;
    }

    // select individual store
    if (this.storeId) {
      this.stores = this.stores.filter(store => {
        if (store.id == this.storeId) {
          return true;
        } else {
          return false;
        }
      });
    }

    EventBus.$on('MAP_POPULATE', (searchId, locations) => {
      if (searchId == this.searchId && this.isReady) {
        this.setBounds(locations);
      }
    });

    EventBus.$on('MAP_LOADING', (searchId) => {
      if (searchId == this.searchId) {
        this.isLoading = true;
      }
    });

    EventBus.$on('STORE_HIDE', (searchId, locations) => {
      if (searchId == this.searchId) {
        this.deactivateMarkers();
        if (this.prevZoom) {
          this.map.setZoom(this.prevZoom);
        }
      }
    });

    EventBus.$on('STORE_DISPLAY', (searchId, store) => {
      if (searchId == this.searchId) {
        this.activateMarker(store.id);
      }
    });

    EventBus.$on('STORE_HIGHLIGHT', (searchId, store) => {
      if (searchId == this.searchId) {
        this.highlightMarker(store.id);
      }
    });

    EventBus.$on('STORE_UNHIGHLIGHT', (searchId, store) => {
      if (searchId == this.searchId) {
        this.unhighlightMarker(store.id);
      }
    });

    EventBus.$on('LOCALSTORE_SET', (store) => {
      // if (this.searchId == 'sidebar') {
      //   this.highlightMarker(store.id);
      // }
    });

    try {
      const google = await gmapsInit();

      this.isReady = true;
      this.initMap();
      this.setMarkers(this.stores);

    } catch (error) {
      console.error(error);
    }

  },
};
</script>

<style scoped>
</style>